<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main" style="background-color: #fff; padding: 120px 0;">
					<div class="login_main">
						<el-row>
							<el-col :span="20" :offset="2">
								<div class="login_qrcode">
									<div class="login_qrcode_title">
										微信扫码支付（支付{{price}}，获取会员权限）
									</div>
									<div class="login_qrcode_img">
										<div id="qrCode" ref="qrCodeDiv" style="width: 200px; height: 200px; margin: auto;"></div>
										<div class="login_qrcode_summary">
											打开手机微信扫一扫 支付订单费用
										</div>
									</div>
									
									<div class="login_qrcode_note">
										温馨提示：<br/>
										1、首次扫码需要关注“强企宝典”公众号后自动登录<br/>
										2、二维码有效期3分钟，超时后请重新获取<br/>
										<!-- 请确认使用同一个微信号；请确认关注了“强企宝典”服务号；<br/>
										还有问题，请联系我们； -->
									</div>
								</div>
							</el-col>
							<!-- <el-col :span="6":offset="3">
								<div class="login_image">
									<div class="login_image_text">
										企业发展导航<br/>
										老板圆梦陪伴<br/>
										服务能力提升<br/>
										学者深度学习<br/>
										政府梯次培育<br/>
									</div>
								</div>
							</el-col> -->
						</el-row>
					</div>
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import QRCode from 'qrcodejs2';
	export default {
		components: {
			HeaderCus,
			FooterCus,
		},
		data() {
			return {
				payment_uuid: '',
				payment_qrcode: '',
				code_url: '',
				count: 0,
				cur_user: {},
				price: '',
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.loadPrice(10105) // 加载价格
			
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			this.cur_user = JSON.parse(localStorage.getItem('cur_user'));
			if (this.cur_user == null || this.cur_user == {}) {
				this.$message({
					message: '未登录用户，请登陆后再支付',
					type: 'error',
				});
				setTimeout(()=>{
					this.toUrl('login')
				}, 1500)
			} else {
				this.createQrcode()
			}
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					this.$router.push({path: url})
				}
			},
			
			// 创建支付二维码
			createQrcode() {
				let url = 'https://sudomanage.qqbd.vip/pubapi/pub_user_payment/newPayment25M'
				// let url = 'http://localhost:58080/pubapi/pub_user_payment/newPayment10'
				let client_data = this.$qs.stringify({userId: this.cur_user.id, userName: this.cur_user.openidmp})
				this.$axios.post(url, client_data).then((res)=>{
					console.log(res.data.data)
					this.code_url = res.data.data.codeUrl
					this.bindQRCode()
					this.checkPayment(res.data.data.id)
				})
			},
			
			// 定时监测支付结果状态是否更新
			checkPayment(id) {
				let task = setInterval(() => {
					this.count += 1
					let url = this.$common.apiUrl + 'pub_user_payment/detail/' + id
					this.$axios.get(url).then((res)=>{
						// console.log('支付数据：',res.data.data)
						let status = res.data.data.isSuccess
						if (status == '1') {
							// console.log('is_pay_success')
							clearInterval(task)
							this.$message({
								message: '支付成功，进入我的订单查看订单流水',
								type: 'success',
							});
							setTimeout(()=>{
								this.toUrl('user_payment')
							}, 1500)
						} else {
							// console.log('未扫码')
							console.log(this.count)
							if (this.count >= 60) {
								console.log('已超时，停止获取支付结果数据')
								clearInterval(task)
							}
						}
					})
				}, 2000)
			},
			
			// vue生成二维码并绑定在div上
			bindQRCode() {
				new QRCode(this.$refs.qrCodeDiv, {
					text: this.code_url,
					width: 200,
					height: 200,
					colorDark: "#000", //二维码颜色
					colorLight: "#fff", //二维码背景色
					correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
				})
			},
			
			// 加载价格
			loadPrice(config_id) {
				let url = this.$common.apiUrl + 'pub_web_config/detail/' + config_id
				this.$axios.get(url).then((res) => {
					let obj = eval('(' + res.data.data.configJson + ')')
					this.price = obj.price25Ver1m
				})
			},
			
			
			
		}
	}
</script>

<style scoped>
</style>